import { Button } from 'antd';
import { useEffect, useState } from 'react';
import { Col, Row } from 'antd';

import styles from './data.module.scss';
import { Link } from 'react-router-dom';
import authService from 'core/services/auth';
import { Admin } from 'modules/admins/models/Admin';

function ProfileDataComponent() {
	const [admin, setAdmin] = useState<Admin | null>();
	const [roles, setRoles] = useState<string[]>([]);

	useEffect(() => {
		const admin = authService.getUser();
		setAdmin(admin);

		setRoles(admin?.roles.map((el) => el.name) || []);
	}, []);
	return (
		<>
			<div className="sectionContainer titled">
				<header>Profile Details</header>
				<main className={styles.data}>
					<Row>
						<Col xs={10} md={6} className={styles.title}>
							Full Name
						</Col>
						<Col xs={14} md={18}>
							{admin?.name}
						</Col>
					</Row>
					<Row>
						<Col xs={10} md={6} className={styles.title}>
							Email
						</Col>
						<Col xs={14} md={18}>
							{admin?.email}
						</Col>
					</Row>
					<Row>
						<Col xs={10} md={6} className={`${styles.title} d-flex align-items-center`}>
							Roles
						</Col>
						<Col xs={14} md={18}>
							<div className="d-flex gap-1 flex-wrap">
								{roles.map((el) => (
									<span className="status fw-medium" style={{ fontSize: 12 }}>
										{el}
									</span>
								))}
							</div>
						</Col>
					</Row>
				</main>
			</div>

			<div className="sectionContainer titled mb-5">
				<header>Sign-in Method</header>
				<main className="d-flex justify-content-between align-content-center">
					<div className={styles.passDiv}>
						<p>Password</p>
						<span>***********</span>
					</div>

					<Button type="primary" className="discard align-self-center">
						<Link to="change-password" className="text-decoration-none">
							Change password
						</Link>
					</Button>
				</main>
			</div>
		</>
	);
}

export default ProfileDataComponent;
